package com.essntl.features.crm.domain.model

data class OrganizationListModel(
    val id: String,
    val name: String,
    val type: String,
    val website: String?,
    val headcount: Int,
    val contacts: List<ContactOrganizationModel>,
    val expanded: Boolean,
    val logoUrl: String?,
)